import { find, forEach, map, remove } from 'lodash'
import { produce } from 'immer'
import { LocationData } from '../apis/location.api'
import { ActionName } from '../components/Actions'
import { TableHorizontalData } from '../components/TableHorizontal'

export default {
  tableHorizontalData (
    locations: LocationData[]
  ): TableHorizontalData<LocationData>[] {
    forEach(locations, (location: TableHorizontalData<LocationData>) => {
      const actions: ActionName[] = ['edit']
      if (!location.isDeleted) actions.push('delete')
      location.actions = actions
    })
    return locations
  },

  delete (locations: TableHorizontalData<LocationData>[], id: number) {
    return produce(locations, locations => {
      remove(locations, { id })
    })
  },

  selectOptions (locations: LocationData[]) {
    return map(locations, unit => {
      const { name, id } = unit
      return { name, value: String(id) }
    })
  },

  find (locations: LocationData[], id: number) {
    return find(locations, { id })
  }
}
